var map = {
	"./alchemy_mini.png": "cc20",
	"./autobackups_mini.png": "77ef",
	"./canon_mini.png": "1500",
	"./dashboards_mini.png": "ed03",
	"./fluxity_mini.png": "0660",
	"./integrations_mini.png": "12c6",
	"./kairos_mini.png": "760a",
	"./panoptico_mini.png": "2897",
	"./suite_mini.png": "09ee",
	"./synapse_mini.png": "bb2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "505a";